import React, { useMemo } from "react";
import Flx from "../../../components/layout/Flx";
import Txt from "../../../components/typography/Txt";
import { Divider } from "@mui/material";
import { useFormState } from "react-final-form";
import { selectOptionsLoanPurposeQuickApp } from "../../../constants/selectOptions/selectOptionsLoanPurposeQuickApp";
import { selectOptionsLoanProductTypeQuickApp } from "../../../constants/selectOptions/selectOptionsLoanProductTypeQuickApp";
import { getSelectOptionLabel } from "../../../_src_shared/utils/functions/getSelectOptionLabel";

const ProductDescription = ({ children }) => {
  const { values } = useFormState();

  const formattedLoanProductType = useMemo(() => {
    return getSelectOptionLabel(
      selectOptionsLoanProductTypeQuickApp,
      values?.loanProductType
    );
  }, [values?.loanProductType]);

  const formattedLoanPurpose = useMemo(() => {
    return getSelectOptionLabel(
      selectOptionsLoanPurposeQuickApp,
      values?.loanPurpose
    );
  }, [values?.loanPurpose]);
  const txtStyles = useMemo(
    () => ({ fontSize: "11px", fontStyle: "italic" }),
    []
  );
  return (
    <Flx sx={{ position: "absolute", left: 0, top: -18 }} alignItems="center">
      <Txt sx={txtStyles} secondary>
        {formattedLoanPurpose}
      </Txt>
      <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
      <Txt sx={txtStyles} secondary>
        {formattedLoanProductType}
      </Txt>
    </Flx>
  );
};

export default ProductDescription;
